import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { NavbarComponent } from '../../components/navbar/navbar.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { ReservationService } from '../../services/reservation.service';

@Component({
  selector: 'app-payment-failure',
  standalone: true,
  imports: [
    CommonModule,
    NavbarComponent,
    FooterComponent
  ],
  templateUrl: './payment-failure.component.html',
  styleUrl: './payment-failure.component.css'
})
export class PaymentFailureComponent implements OnInit {
  reservation_id: string | null = null;
  payment_id: string | null = null;
  collection_status: string | null = null;
  isLoading = true;
  error: string | null = null;
  paymentDetails: any = null;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly reservationService: ReservationService
  ) {}

  ngOnInit(): void {
    // Extraer parámetros de la URL de retorno de MercadoPago
    this.route.queryParams.subscribe(params => {
      this.reservation_id = params['external_reference']; // El reservation_id viene en external_reference
      this.payment_id = params['payment_id'];
      this.collection_status = params['collection_status'];

      if (this.reservation_id) {
        this.verifyPaymentStatus();
      } else {
        this.error = 'No se encontró información de la reserva en la URL de retorno.';
        this.isLoading = false;
      }
    });
  }

  /**
   * Verificar el estado final del pago con delay para dar tiempo al webhook
   */
  verifyPaymentStatus(): void {
    if (!this.reservation_id) return;

    console.log('🔍 Verificando estado de pago (failure) para reservation_id:', this.reservation_id);
    
    // Agregar delay de 2 segundos para dar tiempo al webhook
    setTimeout(() => {
      this.checkPaymentStatus();
    }, 2000);
  }

  /**
   * Consultar el estado de pago al endpoint correcto
   */
  private checkPaymentStatus(): void {
    if (!this.reservation_id) return;

    this.reservationService.getPaymentStatus(this.reservation_id).subscribe({
      next: (response) => {
        console.log('✅ Respuesta del backend (failure) recibida:', response);
        
        if (!response) {
          console.error('❌ Respuesta vacía del backend');
          this.error = 'No se recibió información del estado del pago. Verifica desde tu dashboard de reservas.';
          this.isLoading = false;
          return;
        }

        // Extraer el status correctamente según la estructura del backend
        const paymentStatus = response.status || response.payment_status;
        console.log('💳 Estado de pago extraído (failure):', paymentStatus);

        // Estructura los datos para el template
        this.paymentDetails = {
          ...response,
          payment: {
            status: this.mapBackendStatusToFrontend(paymentStatus),
            status_description: response.payment_method ? `Intento con ${response.payment_method}` : undefined,
            mp_payment_id: response.mp_payment_id,
            amount: response.amount
          }
        };

        this.isLoading = false;
      },
      error: (error) => {
        console.error('❌ Error verificando estado de pago:', error);
        
        if (error.status === 404) {
          this.error = 'No se encontró información de esta reserva.';
        } else if (error.status === 500) {
          this.error = 'Error interno del servidor. Verifica desde tu dashboard de reservas.';
        } else {
          this.error = `Error al verificar el estado del pago (${error.status}). Verifica desde tu dashboard de reservas.`;
        }
        
        this.isLoading = false;
      }
    });
  }

  /**
   * Mapear estados del backend a estados del frontend
   */
  private mapBackendStatusToFrontend(backendStatus: string): string {
    const statusMap: { [key: string]: string } = {
      'completed': 'Pagado',
      'approved': 'Pagado',
      'pending': 'Pendiente de pago',
      'in_process': 'Procesando',
      'rejected': 'Pago rechazado',
      'cancelled': 'Cancelado',
      'failure': 'Pago rechazado'
    };

    return statusMap[backendStatus] || backendStatus;
  }

  /**
   * Redirigir al dashboard de reservas para reintentar el pago
   */
  retryPayment(): void {
    this.router.navigate(['/my-reservations']);
  }

  /**
   * Redirigir a inicio
   */
  goToHome(): void {
    this.router.navigate(['/']);
  }
}
